/**
 * 审批管理
 **/

export default [
  {
    label: '审批管理',
    icon: 'icon-shezhi',
    permission:'appr_manage',
    id:'6',
    children: [
      {
        label: '审批设置',
        icon: 'icon-yonghu',
        path: '/appr/manage',
        permission: 'appr_manage',
        id:'6-1',
      }
    ],
  },
]
